export type CustomerLevelOption = {
  value: string;
  label: string;
  description?: string;
};

export type CustomerLevelDisplay = {
  label: string;
  description?: string;
  text: string;
  status: 'configured' | 'ungraded' | 'unconfigured';
};

const DEFAULT_DESCRIPTIONS: Record<string, string> = {
  A: '高价值重点客户',
  B: '重点跟进客户',
  C: '持续培育客户',
  D: '低优先级 / 待激活客户',
};

const normalize = (value: unknown) => String(value ?? '').trim();

export const resolveCustomerLevelDescription = (
  label: string,
  description?: string,
) => {
  const configuredDescription = normalize(description);
  if (configuredDescription) return configuredDescription;
  const matched = normalize(label).match(/^([A-D])(?:级)?(?:客户)?$/i);
  return matched ? DEFAULT_DESCRIPTIONS[matched[1].toUpperCase()] : undefined;
};

export const formatCustomerLevelOption = (option: CustomerLevelOption) => {
  const label = normalize(option.label);
  const description = resolveCustomerLevelDescription(
    label,
    option.description,
  );
  return description ? `${label} · ${description}` : label;
};

export const resolveCustomerLevelDisplay = (
  value: unknown,
  options: CustomerLevelOption[],
): CustomerLevelDisplay => {
  const normalizedValue = normalize(value);
  if (!normalizedValue) {
    return { label: '未分级', text: '未分级', status: 'ungraded' };
  }
  const option = options.find(
    (item) => normalize(item.value) === normalizedValue,
  );
  if (!option) {
    return { label: '等级待配置', text: '等级待配置', status: 'unconfigured' };
  }
  const label = normalize(option.label);
  const description = resolveCustomerLevelDescription(
    label,
    option.description,
  );
  return {
    label,
    description,
    text: description ? `${label} · ${description}` : label,
    status: 'configured',
  };
};
